import { ReportSlice } from "@sportal/api/reports";

import {
  DataKeys,
  ReportsPeriod,
} from "../../../../helpers/reports.helper.types";
import { LoadingState } from "../../../shared/withLoadableSlice.types";

export const LOAD_WIDGET = "[REPORTS] LOAD_WIDGET";
export const LOAD_WIDGET_SUCCESS = "[REPORTS] LOAD_WIDGET_SUCCESS";
export const LOAD_WIDGET_FAILURE = "[REPORTS] LOAD_WIDGET_FAILURE";

interface LoadWidgetAction {
  type: typeof LOAD_WIDGET;
  payload: { id: DataKeys; period: ReportsPeriod };
}

interface LoadWidgetSuccessAction {
  type: typeof LOAD_WIDGET_SUCCESS;
  payload: { id: DataKeys; data: ReportSlice[]; period: ReportsPeriod };
}

interface LoadWidgetFailureAction {
  type: typeof LOAD_WIDGET_FAILURE;
  payload: { id: DataKeys; error: any; period: ReportsPeriod };
}

export type WidgetActionTypes =
  | LoadWidgetAction
  | LoadWidgetSuccessAction
  | LoadWidgetFailureAction;

export interface WidgetState extends LoadingState {
  data: ReportSlice[];
  period: any;
}
